import { Model } from 'vuex-orm';

import App from '../app/model';
import AppMembership from '../appMembership/model';

export default class AppPackage extends Model {
  static entity = 'packages';

  static fields() {
    return {
      id: this.attr(null),
      app_id: this.attr(null),
      uuid: this.attr(''),
      name: this.attr(''),
      machine_name: this.attr(''),
      max_users: this.attr(''),
      active: this.attr(''),

      app: this.belongsTo(App, 'app_id'),
      appMemberships: this.hasMany(AppMembership, 'package_id'),
    };
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/package/model.js